@if (truncMode() === truncationMode.End) {
  <div class="text ellipsis-end">{{ text }}</div>
}
@if (truncMode() === truncationMode.Start) {
  <div class="text ellipsis-start">{{ text }}</div>
}
@if (truncMode() === truncationMode.Middle && text) {
  <div #ellipsisMiddle>
    <span
      #ellipsisStart
      class="text ellipsis-middle-start"
      [class.ellipsis-middle-start-full]="(needsTruncation | async) === false"
      >
      {{ text }} </span
      ><!--
      -->@if (needsTruncation | async) {
      <span class="text ellipsis-middle-end">{{ text }}</span>
    }
  </div>
}
